import { getRootDomain } from '../utils/stringUtil';

const FairplayLogo = 'theme/Fairplaylive/title.png';
const FairplayIcon = 'theme/Fairplaylive/favicon.png';
const Strike46Logo = 'theme/Strike46/title.svg';
const Strike46Icon = 'theme/Strike46/favicon.png';
const Strike46Loader = 'theme/Strike46/Loader.gif';
const BigB7Logo = 'theme/BigB7/title.png';
const BigB7Icon = 'theme/BigB7/favicon.svg';
const BigB7Loader = 'theme/BigB7/Loader.gif';
const Hindu777Logo = 'theme/Hindu777/title.png';
const Hindu777Icon = 'theme/Hindu777/favicon.png';
const Hindu777Loader = 'theme/Hindu777/Loader.gif';
const Paddy777Logo = 'theme/Paddy777/title.png';
const Paddy777Icon = 'theme/Paddy777/favicon.png';
const Paddy777Loader = 'theme/Paddy777/Loader.gif';
const Lotus365Logo = 'theme/Lotus365/title.png';
const Lotus365Icon = 'theme/Lotus365/favicon.png';
const Lotus365Loader = 'theme/Lotus365/Loader.gif';
const BidExchLogo = 'theme/BidExch/title.png';
const BidExchIcon = 'theme/BidExch/favicon.png';
const BidExchLoader = 'theme/BidExch/Loader.gif';
const IframeScoreLogo = 'theme/IframeScore/title.png';
const IframeScoreIcon = 'theme/IframeScore/favicon.png';
const IframeScoreLoader = 'theme/IframeScore/Loader.gif';
const Seth247Logo = 'theme/Seth247/title.png';
const Seth247Icon = 'theme/Seth247/favicon.png';
const Seth247Loader = 'theme/Seth247/Loader.gif';
const RajaBetLogo = 'theme/RajaBet/title.png';
const RajaBetIcon = 'theme/RajaBet/favicon.png';
const RajaBetLoader = 'theme/RajaBet/Loader.gif';
const Winfast99Logo = 'theme/Winfast99/title.png';
const Winfast99Icon = 'theme/Winfast99/favicon.png';
const Winfast99Loader = 'theme/Winfast99/Loader.gif';
const Cric199Logo = 'theme/Cric199/title.png';
const Cric199Icon = 'theme/Cric199/favicon.png';
const Cric199Loader = 'theme/Cric199/Loader.gif';
const JkBetsWinLogo = 'theme/JkBetsWin/title.png';
const JkBetsWinIcon = 'theme/JkBetsWin/favicon.png';
const JkBetsWinLoader = 'theme/JkBetsWin/Loader.gif';
const ApexWinLogo = 'theme/ApexWin/title.png';
const ApexWinIcon = 'theme/ApexWin/favicon.png';
const ApexWinLoader = 'theme/ApexWin/Loader.gif';
const ShivShaktiGamingLogo = 'theme/ShivShaktiGaming/title.png';
const ShivShaktiGamingIcon = 'theme/ShivShaktiGaming/favicon.png';
const ShivShaktiGamingLoader = 'theme/ShivShaktiGaming/Loader.gif';
const King123Logo = 'theme/King123/title.png';
const King123Icon = 'theme/King123/favicon.png';
const King123Loader = 'theme/King123/Loader.gif';
const StakeVipLogo = 'theme/StakeVip/title.png';
const StakeVipIcon = 'theme/StakeVip/favicon.png';
const StakeVipLoader = 'theme/StakeVip/Loader.gif';
const winballys365Logo = 'theme/Winballys365/title.png';
const winballys365Icon = 'theme/Winballys365/favicon.png';
const winballys365Loader = 'theme/Winballys365/Loader.gif';
const ultrawin247Logo = 'theme/UltraWin247/title.png';
const ultrawin247Icon = 'theme/UltraWin247/favicon.png';
const ultrawin247Loader = 'theme/UltraWin247/Loader.gif';
const pridegames99Logo = 'theme/PrideGames99/title.png';
const pridegames99Icon = 'theme/PrideGames99/favicon.png';
const pridegames99Loader = 'theme/PrideGames99/Loader.gif';
const momowin777Logo = 'theme/MomoWin777/title.png';
const momowin777Icon = 'theme/MomoWin777/favicon.png';
const momowin777Loader = 'theme/MomoWin777/Loader.gif';
const bigwin2026Logo = 'theme/BigWin2026/title.png';
const bigwin2026Icon = 'theme/BigWin2026/favicon.png';
const bigwin2026Loader = 'theme/BigWin2026/Loader.gif';
const kabookVipLogo = 'theme/KabookVip/title.png';
const kabookVipIcon = 'theme/KabookVip/favicon.png';
const kabookVipLoader = 'theme/KabookVip/Loader.gif';
const bossBetVipLogo = 'theme/BossBetVip/title.png';
const bossBetVipIcon = 'theme/BossBetVip/favicon.png';
const bossBetVipLoader = 'theme/BossBetVip/Loader.gif';


const BypandaLogo = 'theme/Bypanda/title.png';
const BypandaIcon = 'theme/Bypanda/favicon.png';
const BypandaLoader = 'theme/Bypanda/Loader.gif';
const xplayxLogo = 'theme/xplayx/title.png';
const xplayxIcon = 'theme/xplayx/favicon.png';
const xplayxLoader = 'theme/xplayx/Loader.gif';
const xplayx2Logo = 'theme/xplayx2/title.png';
const xplayx2Icon = 'theme/xplayx2/favicon.png';
const xplayx2Loader = 'theme/xplayx2/Loader.gif';
const xplayx3Logo = 'theme/xplayx3/title.png';
const xplayx3Icon = 'theme/xplayx3/favicon.png';
const xplayx3Loader = 'theme/xplayx3/Loader.gif';
const xplayxyLogo = 'theme/xplayxy/title.png';
const xplayxyIcon = 'theme/xplayxy/favicon.png';
const xplayxyLoader = 'theme/xplayxy/Loader.gif';
const winx6Logo = 'theme/winx6/title.png';
const winx6Icon = 'theme/winx6/favicon.png';
const winx6Loader = 'theme/winx6/Loader.gif';
const winx7Logo = 'theme/winx7/title.png';
const winx7Icon = 'theme/winx7/favicon.png';
const winx7Loader = 'theme/winx7/Loader.gif';
const winx9Logo = 'theme/winx9/title.png';
const winx9Icon = 'theme/winx9/favicon.png';
const winx9Loader = 'theme/winx9/Loader.gif';
const winx8Logo = 'theme/winx8/title.png';
const winx8Icon = 'theme/winx8/favicon.png';
const winx8Loader = 'theme/winx8/Loader.gif';
const boomx1Logo = 'theme/boomx1/title.png';
const boomx1Icon = 'theme/boomx1/favicon.png';
const boomx1Loader = 'theme/boomx1/Loader.gif';
const boomx3Logo = 'theme/boomx3/title.png';
const boomx3Icon = 'theme/boomx3/favicon.png';
const boomx3Loader = 'theme/boomx3/Loader.gif';
export interface WhitelabelEnvDTO {
  FOLDER_NAME: string;
  BRAND_NAME: string;
  BRAND_DOMAIN: string;
  logo: any;
  favicon: any;
  Loader: any;
  telegramBot?: string;
  skins?: Array<{
    label: string;
    domain: string;
    disabled?: boolean;
  }>;
}

const faiplayLiveEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Fairplaylive',
  BRAND_NAME: 'Fairplay',
  BRAND_DOMAIN: 'fairplay.live',
  logo: FairplayLogo,
  favicon: FairplayIcon,
  Loader: Strike46Loader,
  telegramBot: 'https://t.me/fairplay_bot',
};


// const ultrawinCoEnvs: WhitelabelEnvDTO = {
//   FOLDER_NAME: 'Ultrawin',
//   BRAND_NAME: 'Ultrawin',
//   BRAND_DOMAIN: 'ultrawin.games',
//   logo: Strike46Logo,
//   favicon: Strike46Icon,
//   Loader: Strike46Loader,
//   skins: [
//     {
//       label: '99exch',
//       domain: `diamond.${getRootDomain()}`,
//     },
//     {
//       label: 'Lotus',
//       domain: `lotus.${getRootDomain()}`,
//     },
//     {
//       label: 'Ultrawin',
//       domain: `${getRootDomain()}`,
//       disabled: true,
//     },
//   ],
// };

const strike46Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Strike46',
  BRAND_NAME: 'Strike46',
  BRAND_DOMAIN: 'web.strike46.com',
  logo: Strike46Logo,
  favicon: Strike46Icon,
  Loader: Strike46Loader,
  telegramBot: 'https://t.me/strike46_bot',
};

const bigb7Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'BigB7',
  BRAND_NAME: 'BigB7',
  BRAND_DOMAIN: 'bigb7.strike46.com',
  logo: BigB7Logo,
  favicon: BigB7Icon,
  Loader: BigB7Loader,
  telegramBot: 'https://t.me/bigb7_bot',
};

const hindu777Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Hindu777',
  BRAND_NAME: 'Hindu777',
  BRAND_DOMAIN: 'hindu777.strike46.com',
  logo: Hindu777Logo,
  favicon: Hindu777Icon,
  Loader: Hindu777Loader,
  telegramBot: 'https://t.me/hindu777_bot',
};

const paddy777Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Paddy777',
  BRAND_NAME: 'Paddy777',
  BRAND_DOMAIN: 'paddy777.co',
  logo: Paddy777Logo,
  favicon: Paddy777Icon,
  Loader: Paddy777Loader,
  telegramBot: 'https://t.me/paddy777_bot',
};

const lotus365Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Lotus365',
  BRAND_NAME: 'Lotus365',
  BRAND_DOMAIN: 'lotusid365.live',
  logo: Lotus365Logo,
  favicon: Lotus365Icon,
  Loader: Lotus365Loader,
  telegramBot: 'https://t.me/lotusid365bot',
};

const bidExchEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'BidExch',
  BRAND_NAME: 'BidExch',
  BRAND_DOMAIN: 'bidexch.live',
  logo: BidExchLogo,
  favicon: BidExchIcon,
  Loader: BidExchLoader,
  telegramBot: 'https://t.me/bidexch_bot',
};

const StrikeIdEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Strike46',
  BRAND_NAME: 'Strike46',
  BRAND_DOMAIN: 'app.strike46.com',
  logo: Strike46Logo,
  favicon: Strike46Icon,
  Loader: Strike46Loader,
  telegramBot: 'https://t.me/@StrikeID_bot',
};

const iframeScoreEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'IframeScore',
  BRAND_NAME: 'IframeScore',
  BRAND_DOMAIN: 'iframescore.com',
  logo: IframeScoreLogo,
  favicon: IframeScoreIcon,
  Loader: IframeScoreLoader,
  telegramBot: 'https://t.me/iframescore_bot',
};

const seth247Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Seth247',
  BRAND_NAME: 'Seth247',
  BRAND_DOMAIN: 'seth247.com',
  logo: Seth247Logo,
  favicon: Seth247Icon,
  Loader: Seth247Loader,
  telegramBot: 'https://t.me/seth247_bot',
};

const rajaBetEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'RajaBet',
  BRAND_NAME: 'RajaBet',
  BRAND_DOMAIN: 'rajabet.win',
  logo: RajaBetLogo,
  favicon: RajaBetIcon,
  Loader: RajaBetLoader,
  telegramBot: 'https://t.me/rajabetwin_bot',
};

const winfast99Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Winfast99',
  BRAND_NAME: 'Winfast99',
  BRAND_DOMAIN: 'winfast99.tech',
  logo: Winfast99Logo,
  favicon: Winfast99Icon,
  Loader: Winfast99Loader,
  telegramBot: 'https://t.me/winfast99_bot',
};

const cric199Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Cric199',
  BRAND_NAME: 'Cric199',
  BRAND_DOMAIN: 'cric199.com',
  logo: Cric199Logo,
  favicon: Cric199Icon,
  Loader: Cric199Loader,
  telegramBot: 'https://t.me/cric199_bot',
};

const khelo365daysEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Cric199',
  BRAND_NAME: 'Khelo365days',
  BRAND_DOMAIN:  'khelo365days.com',
  logo: Cric199Logo,
  favicon: Cric199Icon,
  Loader: Cric199Loader,
  telegramBot: 'https://t.me/cric199_bot',
};

const jkBetsWinEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'JkBetsWin',
  BRAND_NAME: 'JkBetsWin',
  BRAND_DOMAIN: 'jkbetswin.com',
  logo: JkBetsWinLogo,
  favicon: JkBetsWinIcon,
  Loader: JkBetsWinLoader,
  telegramBot: 'https://t.me/jkbetswin_bot',
};

const apexWinEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'ApexWin',
  BRAND_NAME: 'ApexWin',
  BRAND_DOMAIN: 'apexwin.club',
  logo: ApexWinLogo,
  favicon: ApexWinIcon,
  Loader: ApexWinLoader,
  telegramBot: 'https://t.me/apexwinclub_bot',
};

const shivShaktiGamingEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'ShivShaktiGaming',
  BRAND_NAME: 'ShivShaktiGaming',
  BRAND_DOMAIN: 'shivshaktigaming.com',
  logo: ShivShaktiGamingLogo,
  favicon: ShivShaktiGamingIcon,
  Loader: ShivShaktiGamingLoader,
  telegramBot: 'https://t.me/shivshaktigaming_bot',
};

const king123Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'King123',
  BRAND_NAME: 'King123',
  BRAND_DOMAIN: 'king123.online',
  logo: King123Logo,
  favicon: King123Icon,
  Loader: King123Loader,
  telegramBot: 'https://t.me/king123online_bot',
};

const stakeVipEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'StakeVip',
  BRAND_NAME: 'StakeVip',
  BRAND_DOMAIN: 'stakevip.in',
  logo: StakeVipLogo,
  favicon: StakeVipIcon,
  Loader: StakeVipLoader,
  telegramBot: 'https://t.me/stakevipin_bot',
};

const winballys365Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'WinBallys365',
  BRAND_NAME: 'WinBallys365',
  BRAND_DOMAIN: 'winballys365.strike46.com',
  logo: winballys365Logo,
  favicon: winballys365Icon,
  Loader: winballys365Loader,
  telegramBot: 'https://t.me/winballys365_bot',
};

const ultrawin247Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'UltraWin247',
  BRAND_NAME: 'UltraWin247',
  BRAND_DOMAIN: 'ultrawin247.com',
  logo: ultrawin247Logo,
  favicon: ultrawin247Icon,
  Loader: ultrawin247Loader,
  telegramBot: 'https://t.me/ultrawin247_bot',
};

const pridegames99Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'PrideGames99',
  BRAND_NAME: 'PrideGames99',
  BRAND_DOMAIN: 'pridegames99.com',
  logo: pridegames99Logo,
  favicon: pridegames99Icon,
  Loader: pridegames99Loader,
  telegramBot: 'https://t.me/pridegames99_bot',
};

const momowin777Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Momowin777',
  BRAND_NAME: 'Momowin777',
  BRAND_DOMAIN: 'momowin777.com',
  logo: momowin777Logo,
  favicon: momowin777Icon,
  Loader: momowin777Loader,
  telegramBot: 'https://t.me/momowin777_bot',
};

const bigwin2026Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'BigWin2026',
  BRAND_NAME: 'BigWin2026',
  BRAND_DOMAIN: 'bigwin2026.com',
  logo: bigwin2026Logo,
  favicon: bigwin2026Icon,
  Loader: bigwin2026Loader,
  telegramBot: 'https://t.me/bigwin2026_bot',
};

const kabookVipEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'KabookVip',
  BRAND_NAME: 'KabookVip',
  BRAND_DOMAIN: 'kabookvip.com',
  logo: kabookVipLogo,
  favicon: kabookVipIcon,
  Loader: kabookVipLoader,
  telegramBot: 'https://t.me/kabookvip_bot',
};

const bossBetVipEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'BossBetVip',
  BRAND_NAME: 'BossBetVip',
  BRAND_DOMAIN: 'bossbetvip.com',
  logo: bossBetVipLogo,
  favicon: bossBetVipIcon,
  Loader: bossBetVipLoader,
  telegramBot: 'https://t.me/bossbetvip_bot',
};

const winzeeEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'BossBetVip',
  BRAND_NAME: 'Winzee',
  BRAND_DOMAIN: 'winzee.club',
  logo: bossBetVipLogo,
  favicon: bossBetVipIcon,
  Loader: bossBetVipLoader,
  telegramBot: 'https://t.me/winzee_bot',
};


const bypandaEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'Bypanda',
  BRAND_NAME: 'Bypanda',
  BRAND_DOMAIN: 'strike46.games',
  logo: BypandaLogo,
  favicon: BypandaIcon,
  Loader: BypandaLoader,
  telegramBot: 'https://t.me/Bypanda_bot/home',
};


const xplayxEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'xplayx',
  BRAND_NAME: 'xplayx',
  BRAND_DOMAIN: 'xplayx.st247id.site',
  logo: xplayxLogo,
  favicon: xplayxIcon,
  Loader: xplayxLoader,
};


const xplayx2Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'xplayx2',
  BRAND_NAME: 'xplayx2',
  BRAND_DOMAIN: 'xplayx2.st247id.site',
  logo: xplayx2Logo,
  favicon: xplayx2Icon,
  Loader: xplayx2Loader,
};


const xplayx3Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'xplayx3',
  BRAND_NAME: 'xplayx3',
  BRAND_DOMAIN: 'xplayx3.fantasyid.site',
  logo: xplayx3Logo,
  favicon: xplayx3Icon,
  Loader: xplayx3Loader,
};


const xplayxyEnvs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'xplayxy',
  BRAND_NAME: 'xplayxy',
  BRAND_DOMAIN: 'xplayxy.fantasyid.site',
  logo: xplayxyLogo,
  favicon: xplayxyIcon,
  Loader: xplayxyLoader,
};


const winx6Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'winx6',
  BRAND_NAME: 'winx6',
  BRAND_DOMAIN: 'winx6.fantasyid.site',
  logo: winx6Logo,
  favicon: winx6Icon,
  Loader: winx6Loader,
};


const winx7Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'winx7',
  BRAND_NAME: 'winx7',
  BRAND_DOMAIN: 'winx7.matkaid.site',
  logo: winx7Logo,
  favicon: winx7Icon,
  Loader: winx7Loader,
};


const winx9Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'winx9',
  BRAND_NAME: 'winx9',
  BRAND_DOMAIN: 'winx9.mpid.site',
  logo: winx9Logo,
  favicon: winx9Icon,
  Loader: winx9Loader,
};


const winx8Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'winx8',
  BRAND_NAME: 'winx8',
  BRAND_DOMAIN: 'winx8.st247id.site',
  logo: winx8Logo,
  favicon: winx8Icon,
  Loader: winx8Loader,
};


const boomx1Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'boomx1',
  BRAND_NAME: 'boomx1',
  BRAND_DOMAIN: 'boomx1.st247id.site',
  logo: boomx1Logo,
  favicon: boomx1Icon,
  Loader: boomx1Loader,
};


const boomx3Envs: WhitelabelEnvDTO = {
  FOLDER_NAME: 'boomx3',
  BRAND_NAME: 'boomx3',
  BRAND_DOMAIN: 'boomx3.st247id.site',
  logo: boomx3Logo,
  favicon: boomx3Icon,
  Loader: boomx3Loader,
};

export const WhitelabelEnvMap = {
  'boomx3.st247id.site': boomx3Envs,
  'boomx1.st247id.site': boomx1Envs,
  'winx8.st247id.site': winx8Envs,
  'winx9.mpid.site': winx9Envs,
  'winx7.matkaid.site': winx7Envs,
  'winx6.fantasyid.site': winx6Envs,
  'xplayxy.fantasyid.site': xplayxyEnvs,
  'xplayx3.fantasyid.site': xplayx3Envs,
  'xplayx2.st247id.site': xplayx2Envs,
  'xplayx.st247id.site': xplayxEnvs,
  localhost: bypandaEnvs,

  // Stage domains
  'stage.fairplay.live': faiplayLiveEnvs,
  'web-stage.strike46.com': strike46Envs,

  // Prod domains
  'fairplay.live': faiplayLiveEnvs,
  'strike46.com': strike46Envs,
  'strike46.club': strike46Envs,
  'big7.strike46.com': bigb7Envs,
  'bigb7.strike46.com': bigb7Envs,
  'web.strike46.com': strike46Envs,
  'hindu777.strike46.com': hindu777Envs,
  'www.hinduexch.com': hindu777Envs,
  'hindu777.in': hindu777Envs,
  'paddy777.co': paddy777Envs,
  'paddy777.strike46.com': paddy777Envs,
  'lotusid365.live': lotus365Envs,
  'bidexch.live': bidExchEnvs,
  'iframescore.com': iframeScoreEnvs,
  'seth247.com': seth247Envs,
  'rajabet.win': rajaBetEnvs,
  'winfast99.com': winfast99Envs,
  'jkbetswin.com':jkBetsWinEnvs,
  'apexwin.club':apexWinEnvs,
  'shivshaktigaming.com':shivShaktiGamingEnvs,
  'king123.online':king123Envs,
  'stakevip.in': stakeVipEnvs,
  'winballys365.strike46.com': winballys365Envs,
  'ultrawin247.com': ultrawin247Envs,
  'pridegames99.com': pridegames99Envs,
  'momowin777.com': momowin777Envs,
  'bigwin2026.com': bigwin2026Envs,
  'kabookvip.com': kabookVipEnvs,
  'bossbetvip.com': bossBetVipEnvs,
  'winzee.club': winzeeEnvs,
  'winfast99.tech': winfast99Envs,
  'strike46.games': bypandaEnvs,
  'khelo365days.com': khelo365daysEnvs,
  // Aliases
  'fairplay365.games': faiplayLiveEnvs,
  'fairplaysite.co.in': faiplayLiveEnvs,
  'demo.strike46.com': strike46Envs,
  'app.strike46.com': StrikeIdEnvs,
};

export function getEnvVariable(domain: string, variable: keyof WhitelabelEnvDTO): any {
  const cleanDomain = domain.replace(/www./g, '');
  const env = WhitelabelEnvMap[cleanDomain as keyof typeof WhitelabelEnvMap];

  if (!env) {
    throw new Error(`Domain '${cleanDomain}' not found in WhitelabelEnvMap`);
  }

  return env[variable];
}

let cachedLoader: string | null = null;
let isLoaderInitialized = false;

export const getLoader = (domain: string): string => {
  if (isLoaderInitialized && cachedLoader !== null) {
    return cachedLoader;
  }

  const loader = getEnvVariable(domain, 'Loader');
  cachedLoader = typeof loader === 'string' ? loader : String(loader);
  isLoaderInitialized = true;

  return cachedLoader;
};

export const Loader = (domain: string) => getLoader(domain);

export const getTelegramBotLink = (domain: string): string => {
  const cleanDomain = domain.replace(/www./g, '');
  const env = WhitelabelEnvMap[cleanDomain as keyof typeof WhitelabelEnvMap];
  if (!env?.telegramBot) return '';
  const link = String(env.telegramBot).trim();
  return link;
};